import { Box, TableCell, TableRow, Typography, useTheme } from "@mui/material";
import TableActions from "src/common/TableActions";
import { useValidImage } from "src/hooks/useValidImage";
import { IAdminTableRowProps } from "src/Types/module/admin/adminTypes";
import { getStatusLabelAdminFun } from "src/Utils/Combined";

const AdminTableRow = ({ admin, serial }: IAdminTableRowProps) => {
	const imgSrc = useValidImage(admin.user_admin_photo);

	return (
		<>
			<TableRow hover key={admin.user_admin_id}>
				<TableCell>
					<Typography
						variant='body1'
						color='text.primary'
						gutterBottom
						noWrap
					>
						{serial}
					</Typography>
				</TableCell>
				<TableCell>
					<Box sx={{ display: "flex" }}>
						<img
							width={30}
							height={30}
							style={{
								borderRadius: "50%",
								marginRight: "10px",
							}}
							src={imgSrc}
							alt={admin.user_admin_name}
						/>

						<Typography
							variant='body1'
							color='text.primary'
							gutterBottom
							noWrap
						>
							{admin.user_admin_name}
						</Typography>
					</Box>
				</TableCell>
				<TableCell>
					<Box sx={{ display: "flex" }}>
						<Typography
							variant='body1'
							color='text.primary'
							gutterBottom
							noWrap
						>
							{admin.user_admin_email}
						</Typography>
					</Box>
				</TableCell>

				<TableCell>
					<Typography
						variant='body1'
						color='text.primary'
						gutterBottom
						noWrap
					>
						{admin.user_admin_phone}
					</Typography>
				</TableCell>

				<TableCell>
					<Typography
						variant='body1'
						color='text.primary'
						gutterBottom
						noWrap
					>
						{admin.user_admin_role_name}
					</Typography>
				</TableCell>
				{/* <TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{admin.user_admin_zone}
					</Typography>
				</TableCell> */}
				<TableCell>
					{getStatusLabelAdminFun(admin.user_admin_status)}
				</TableCell>
				{/* <TableCell>
					<Link
						to={`/admin-list/single-admin/${admin.user_admin_id}`}
					>
						<Tooltip title="View" arrow>
							<IconButton
								sx={{
									"&:hover": {
										background:
											theme.colors.primary.lighter,
									},
									color: theme.palette.primary.main,
								}}
								color="inherit"
								size="small"
							>
								View
							</IconButton>
						</Tooltip>
					</Link>
				</TableCell> */}
				<TableActions
					showView
					// showDelete
					// handleDeleteFun={() => deleteAdmin()}
					viewLink={`/admin-list/single-admin/${admin.user_admin_id}`}
				/>
			</TableRow>
		</>
	);
};

export default AdminTableRow;
